import AppLayout from "@/layouts/AppLayout.vue";
import McToaster from "@/components/McComponents/McToaster";
export default {
  components: {
    AppLayout: AppLayout,
    McToaster: McToaster
  }
};